module.exports = __webpack_public_path__ + "img/hero-image-01.f3325fb2.jpg";